const events = [

    {
        "date": "2024-03-06",
        "title": "STC Data Science Club Presents",
        "subtitle": "Kamila Stepniowska",
        "description": "Kamila joined NumFOCUS in 2023 as the Projects DEI Coordinator. She has more than decade experience in tech, as entrepreneur, educational programs manager and community builder in Europe and the US. Kamila specialised in AI. In previous years she has been creating B2B, machine learning education programs with deepsense.ai, supporting diversity as COO at Geek Girls Carrots, the Women Who Code Seattle Evangelist, Advisor at She’s Coding, SheWorx Steering Committee members. She brings her experience in DEI, community building and sociology.",
        "imageKey": "kamila",
        "linkText": "LinkedIn",
        "link": "https://www.linkedin.com/in/kamilastepniowska/"
    },
    {
        "date": "2024-03-13",
        "title": "STC Data Science Club Presents",
        "subtitle": "Jim Walseth",
        "description": "We are happy to have Jim Walseth, join us for a hands on introduction to making visualization in Tableau. Jim has over 20 years experience as a software engineer most recently as a Senior Software Engineer at Tableau then moving to a Lead Member of Technical Staff of Software Engineering. \n" +

            "Through out his career Jim has solved problems by the designing and implementation of elegant, enduring code. He has demonstrate leadership skills and sound decision making in a complex environment. Working as a member team and leader to measuring success by improving end users quality of life. \n" +
            "\n" +
            "To demonstrate my leadership skills and sound decision making in a complex environment\n" +
            "Jim is going to give us a chance to follow along. To get the most of this event create a Tableau Public account. Check out Viz of the day see the different types of visualization that are possible. ",
        "imageKey": "jim",
        "linkText": "LinkedIn",
        "link": "https://www.linkedin.com/in/jim-walseth-4633331/"
    }
];
export default events;